// LeftPanel.js
import React from 'react';
import { translations } from './translations';
import '../../styles/css/LeftPanel.css';

const LeftPanel = ({ onButtonClick, language }) => {
  // Map 'ua' to 'uk' for compatibility with translations (ua from profile → uk in translations)
  const langKey = language === 'ua' ? 'uk' : (language || 'en');
  const texts = translations[langKey] || translations.en; // Default to 'en'

  return (
    <div className="left-panel">
      <button onClick={() => onButtonClick(texts.shipments)} className="left-panel-button">{texts.shipments}</button>
      <button onClick={() => onButtonClick(texts.top5SKU)} className="left-panel-button">{texts.top5SKU}</button>
      <button onClick={() => onButtonClick(texts.top5DistributorsMonth)} className="left-panel-button">{texts.top5DistributorsMonth}</button>
       <button onClick={() => onButtonClick(texts.shipmentsDSArmenia)} className="left-panel-button">{texts.shipmentsDSArmenia}</button>
      <button onClick={() => onButtonClick(texts.shipmentsKazakhstan)} className="left-panel-button">{texts.shipmentsKazakhstan}</button>
      <button onClick={() => onButtonClick(texts.zeroShipments)} className="left-panel-button">{texts.zeroShipments}</button>
      <button onClick={() => onButtonClick(texts.salesByBrands)} className="left-panel-button">{texts.salesByBrands}</button>
    </div>
  );
};

export default LeftPanel;
